import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
// import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';
import Button from '@nubank/nuds-web/components/Button/Button';

// import Section from 'components/structure/Section';
import Block from './components/structure/Block/Block.js';
import Carousel from './components/Carousel/Carousel.js';


class SectionSteps extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
    };
  }

  handleChangeCarouselStep = step => {
    this.setState(() => ({
      currentStep: step,
    }));
  };

  render() {
    const { currentStep } = this.state;

    return (


      <Grid
        row
        tag="section"
        alignItems="center"
        justifyContent="center"
        spacingHorizontal={{
          xs: "4x",
          md: "8x",
          lg: "12x",
        }}
        spacingVertical={{
          xs: "6x",
          md: "6x",
          lg: "16x",
        }}
        backgroundColor="white.dark"
      >
        <Grid
          col="fill"
          offset={{
            xs: 0,
            lg: 1,
          }}
        >
          <Typography variant="heading3" gutterBottom={2.5} gutterTop={2.5}>
            Quais são as etapas do processo seletivo?
          </Typography>

          <Grid row alignItems="center" gridColumn={'5 / 11' }>

            <Grid justifyContent="center" col="fill">
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Button variant="contained" styleVariant="primary">
                  1
                </Button>
              </Box>
              <Typography variant="heading3" textAlign="center" color="primary">
                Inscrições
              </Typography>
              <Typography
                variant="paragraph1"
                gutterBottom={1.5}
                textAlign="center"
                color="black"
              >
                Até 18 de março de 2024
              </Typography>
            </Grid>


            <Grid justifyContent="center" col="fill">
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Button variant="contained" styleVariant="primary">
                  2
                </Button>
              </Box>
              <Typography variant="heading3" textAlign="center" color="primary">
                Testes Online
              </Typography>
              <Typography
                variant="paragraph1"
                gutterBottom={1.5}
                textAlign="center"
                color="black"
              >
                Março de 2024
              </Typography>

            </Grid>

            <Grid justifyContent="center" col="fill">
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Button variant="contained" styleVariant="primary">
                  3
                </Button>
              </Box>
              <Typography variant="heading3" textAlign="center" color="primary">
                Dinâmica em grupo
              </Typography>
              <Typography
                variant="paragraph1"
                gutterBottom={1.5}
                textAlign='center'
                color='black'
              >
                Abril de 2024
              </Typography>

            </Grid>


            <Grid justifyContent="center" col="fill">
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Button variant="contained" styleVariant="primary">
                  4
                </Button>
              </Box>
              <Typography variant="heading3" textAlign="center" color="primary">
                Entrevistas
              </Typography>

              <Typography
                variant="paragraph1"
                gutterBottom={1.5}
                textAlign='center'
                color='black'
              >
                Maio de 2024
              </Typography>

            </Grid>

            <Grid justifyContent="center" col="fill">
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Button variant="contained" styleVariant="primary">
                  5
                </Button>
              </Box>
              <Typography variant="heading3" textAlign="center" color="primary">
                Ofertas
              </Typography>

              <Typography
                variant="paragraph1"
                gutterBottom={1.5}
                textAlign='center'
                color='black'
              >
                Junho de 2024
              </Typography>

            </Grid>



          </Grid>
          <Typography
            variant="paragraph1"
            marginHorizontal={{ md: "auto" }}
            textAlign={{ md: "left" }}
            gutterBottom={1.5}
          >
            <br />
            Nota: o processo admissional será feito em Junho de 2024 para o início do estágio em Agosto de 2024
          </Typography>
        </Grid>
      </Grid>


    );
  }
}

export default SectionSteps;
